export default "__VITE_ASSET__CTPD8$r4__"